export default __webpack_public_path__ + "static/media/qris2.a4f5c995.png";